var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 10.8759H1.66663L0.416626 9.20927L2.08329 7.5426H17.9166L19.5833 9.20927L18.3333 10.8759Z",
    fill: "#870000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0833 19.2093H2.91659C2.45617 19.2093 2.08325 18.8363 2.08325 18.3759V0.875936C2.08325 0.415519 2.45617 0.0426025 2.91659 0.0426025H12.9166L17.9166 5.0426V18.3759C17.9166 18.8363 17.5437 19.2093 17.0833 19.2093Z",
    fill: "#E6E6E6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9166 0.0426025V4.20927C12.9166 4.66969 13.2895 5.0426 13.75 5.0426H17.9166L12.9166 0.0426025Z",
    fill: "#B3B3B3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 16.7092H1.24996C0.789543 16.7092 0.416626 16.3363 0.416626 15.8759V9.20923H19.5833V15.8759C19.5833 16.3363 19.2104 16.7092 18.75 16.7092Z",
    fill: "#BD0100"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.36286 12.3947C8.36286 12.7605 8.25495 13.043 8.03953 13.2418C7.8237 13.4414 7.51786 13.5405 7.12078 13.5405H6.87245V14.626H5.98828V11.3539H7.12078C7.53411 11.3539 7.84453 11.4443 8.05161 11.6243C8.25911 11.8051 8.36286 12.0622 8.36286 12.3947ZM6.87245 12.8201H7.0337C7.16662 12.8201 7.27203 12.7826 7.35037 12.7076C7.4287 12.633 7.46786 12.5301 7.46786 12.3993C7.46786 12.1785 7.34578 12.068 7.10078 12.068H6.87245V12.8201Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6617 12.9205C11.6617 13.4668 11.5112 13.8872 11.2104 14.1826C10.91 14.4785 10.4875 14.626 9.94291 14.626H8.88416V11.3539H10.0167C10.5417 11.3539 10.9471 11.488 11.2329 11.7568C11.5187 12.0255 11.6617 12.413 11.6617 12.9205ZM10.7442 12.9518C10.7442 12.6518 10.685 12.4297 10.5662 12.2847C10.4479 12.1397 10.2675 12.0676 10.0258 12.0676H9.76832V13.9001H9.9654C10.2342 13.9001 10.4308 13.8218 10.5562 13.666C10.6817 13.5101 10.7442 13.2726 10.7442 12.9518Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1183 14.626H12.2479V11.3539H14.1817V12.063H13.1188V12.6876H14.0992V13.3968H13.1188V14.626H13.1183Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.e5dc5c9758ac79eac8837e64902c4878.svg";
export { ForwardRef as ReactComponent };